import { Link } from '@tanstack/react-router';
import CabinObjectListItemMetaData from './CabinObjectListItemMetaData';
import {
    AccommodationBookingObjectContentModelContentType,
    AccommodationBookingObjectDto
} from '@shared/integrations/umbraco-taf-delivery-api/models';
import {Card, CardBody, CardMedia, CardTitle} from '@shared/components/Card';
import Markup from "@shared/components/Markup.tsx";

interface IBookingObjectListItemProps {
    item: AccommodationBookingObjectDto;
}

const BookingObjectListItem = ({ item }: IBookingObjectListItemProps) => {
    return (
        <Card className='h-100 rounded-xxl'>
            {item.imageUrl ? (
                <CardMedia>
                    <img
                        src={`${item.imageUrl}?width=700&height=700`}
                        className='rounded-xxl'
                        width={700}
                        height={700}
                        alt={item.name}
                    />
                </CardMedia>
            ) : null}
            <CardBody className='d-flex flex-column gap-2'>
                <header>
                    <div className='kicker font-size-sm'>{item.location}</div>
                    <CardTitle variant='h3'>{item.name}</CardTitle>
                </header>
                {item.bookingObjectType === AccommodationBookingObjectContentModelContentType.accommodationBookingObject ? <CabinObjectListItemMetaData item={item} /> : null}
                <Markup content={item.description} />
            </CardBody>
            {item.url ? (
                <Link
                    to={item.url ?? ''}
                    className='stretched-link stretched-link--hidden'
                ></Link>
            ) : null}
        </Card>
    );
};

export default BookingObjectListItem;
